// eslint-disable-next-line check-file/filename-blocklist
import { styled } from '@compiled/react';

import { token } from '@atlaskit/tokens';

// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled, @atlaskit/ui-styling-standard/no-exported-styles -- Ignored via go/DSP-18766
export const SearchResultItem = styled.li({
	display: 'flex',
	paddingBottom: token('space.100'),
	flexDirection: 'column',
	// eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-selectors -- Ignored via go/DSP-18766
	'&:not(:first-of-type)': {
		paddingTop: token('space.100'),
	},
});

// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled, @atlaskit/ui-styling-standard/no-exported-styles -- Ignored via go/DSP-18766
export const LastModifiedWrapper = styled.div({
	font: token('font.body.small'),
	color: token('color.text'),
	verticalAlign: 'baseline',
});

// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled, @atlaskit/ui-styling-standard/no-exported-styles -- Ignored via go/DSP-18766
export const ResultContainer = styled.div({
	display: 'flex',
	padding: 0,
	flexDirection: 'column',
});

// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled, @atlaskit/ui-styling-standard/no-exported-styles -- Ignored via go/DSP-18766
export const ResultMainContainer = styled.div({
	display: 'flex',
	alignItems: 'initial',
	// eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
	'> div > span > svg': {
		paddingTop: token('space.050'),
	},
});

// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled, @atlaskit/ui-styling-standard/no-exported-styles -- Ignored via go/DSP-18766
export const ResultIconContainer = styled.div({
	maxWidth: '24px',
	// eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
	'> div > span': {
		height: '24px',
		width: '24px',
		// eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
		'> svg': {
			height: '20px',
			width: '20px',
			padding: `${token('space.050')} ${token('space.025')} 0px ${token('space.025')}`,
		},
		// eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
		'> img': {
			height: '20px',
			width: '20px',
		},
	},
});

// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled, @atlaskit/ui-styling-standard/no-exported-styles -- Ignored via go/DSP-18766
export const ResultTitleMetadataContainer = styled.div({
	padding: `0 0 0 ${token('space.100')}`,
	overflow: 'hidden',
	flexGrow: 1,
});

// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled, @atlaskit/ui-styling-standard/no-exported-styles -- Ignored via go/DSP-18766
export const ResultTitle = styled.div({
	display: 'flex',
	whiteSpace: 'nowrap',
	overflowX: 'hidden',
	textOverflow: 'ellipsis',
	paddingBottom: token('space.025'),
	// eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
	'.searchResultLink:visited': {
		color: token('color.text.discovery'),
	},
	// eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
	'.searchResultLink:visited:hover': {
		color: token('color.text.discovery'),
		textDecoration: 'underline',
	},
});

// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled, @atlaskit/ui-styling-standard/no-exported-styles -- Ignored via go/DSP-18766
export const ResultMetadata = styled.div({
	color: token('color.chart.neutral'),
	margin: `${token('space.025')} 0 0 0`,
	font: token('font.body.small'),
	display: 'flex',
	alignItems: 'baseline',
	// eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
	'> a': {
		color: token('color.text'),
		'&:visited': {
			color: token('color.text'),
		},
		'&:hover': {
			color: token('color.text.information'),
		},
	},
	flexWrap: 'wrap',
});

// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled, @atlaskit/ui-styling-standard/no-exported-styles -- Ignored via go/DSP-18766
export const ResultExcerptContainer = styled.div({
	flexGrow: 1,
	overflow: 'hidden',
	overflowWrap: 'break-word',
	padding: `${token('space.025')} 0 0 ${token('space.400')}`,
});

// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled, @atlaskit/ui-styling-standard/no-exported-styles -- Ignored via go/DSP-18766
export const ResultLoadingWrapper = styled.div({
	marginBottom: token('space.200'),
});

// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled, @atlaskit/ui-styling-standard/no-exported-styles -- Ignored via go/DSP-18766
export const ResultTitleLoading = styled.div({
	display: 'flex',
	width: '45%',
	height: '16px',
	borderRadius: token('radius.large'),
	background: token('color.skeleton'),
});

// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled, @atlaskit/ui-styling-standard/no-exported-styles -- Ignored via go/DSP-18766
export const ResultMetaLoading = styled.div({
	display: 'flex',
	width: '33%',
	height: '12px',
	borderRadius: token('radius.large'),
	background: token('color.skeleton'),
	marginTop: token('space.075'),
});

// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled, @atlaskit/ui-styling-standard/no-exported-styles -- Ignored via go/DSP-18766
export const ResultExcerptLoadingContainer = styled.div({
	flexGrow: 1,
	overflow: 'hidden',
});

// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled, @atlaskit/ui-styling-standard/no-exported-styles -- Ignored via go/DSP-18766
export const ResultExcerptLoading = styled.div({
	display: 'flex',
	width: '100%',
	height: '16px',
	borderRadius: token('radius.large'),
	background: token('color.skeleton'),
	marginTop: token('space.075'),
});

// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled, @atlaskit/ui-styling-standard/no-exported-styles -- Ignored via go/DSP-18766
export const ResultIconLoading = styled.div({
	width: '24px',
	height: '24px',
	background: token('color.skeleton'),
	borderRadius: token('radius.full'),
});
